import React from "react";
import "./index.css";

import formPag from "../../assets/formPag.png";

const FormasPagamento = () => {
  return (
    <article id="formPag">
      <div className="container">
        <h2 className="title">FORMAS DE PAGAMENTO</h2>

        <p className="text">Aceitamos cartão de crédito, débito e pix.</p>

        <figure>
          <img src={formPag} alt="FORMAS DE PAGAMENTO" />
        </figure>
      </div>
    </article>
  );
};

export default FormasPagamento;
